import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Input from '@lightspeed/cirrus-input';

import Skeleton from './Skeleton';

const STRINGS = {
  DESCRIPTION: 'Configuration Name',
};

const GatewayName = ({ isLoading, fieldName }) =>
  isLoading ? (
    <Skeleton />
  ) : (
    <Card>
      <CardSection noSpacing>
        <div className="cr-flex cr-justify-between cr-items-center cr-pl-3 cr-pr-4 cr-pt-4 cr-pb-4">
          <Field
            name={fieldName}
            render={({ field }) => <Input {...field} label={STRINGS.DESCRIPTION} />}
          />
        </div>
      </CardSection>
    </Card>
  );

GatewayName.propTypes = {
  isLoading: PropTypes.bool,
  fieldName: PropTypes.string,
};

GatewayName.defaultProps = {
  isLoading: true,
  fieldName: 'name',
};

export default GatewayName;
